<template>
  <section class="d-flex flex-column justify-center align-center">
    <face-or-faces
      :servicer="servicer"
      :partner="partner"
    />
    <servicer-info
      class="servicer-info"
      :servicer="servicer"
      :partner="partner"
    />
  </section>
</template>

<script>
import FaceOrFaces from './FaceOrFaces.vue'
import ServicerInfo from './ServicerInfo.vue'
import { NullServicer, NullPartner } from './nullProfile'

export default {
  components: {
    FaceOrFaces,
    ServicerInfo
  },
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => new NullServicer()
    },
    partner: {
      type: Object,
      required: false,
      default: () => new NullPartner()
    }
  }
}
</script>

<style>
  .servicer-info {
    margin-top: 20px
  }
</style>
